import React from 'react';
import PropTypes from 'prop-types';
import CommonLoader from '../CommonLoader';
import './BVLoader20.scss';
import FinancialLoader from '../FinancialLoader';
import ArchivalLoader from '../ArchivalLoader';
import { COLORS } from "Constants/BIDashboardConstants";

const BVLoader20 = (props) => {
  return (
    <div className={"BVwrapper " + (props.centerAlign && 'center-loader')} /* FOUC fix: */ style={{ visibility: 'hidden'}}>
      <div className={props.callingComponent ? "loader-outer-cq" : "loader-outer"}>
        <div className="loader">
          <svg
            version="1.1"
            id="BV2"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            xmlSpace="preserve"
            width={props.width}
            height={props.width}
          >
            <rect id="hp1" className="horizontal1 pill" x="4" y="4" stroke={COLORS.oneGp.deepBlue} strokeWidth="2" fill={COLORS.oneGp.deepBlue} width="93" height="10" />
            <rect id="hp2" className="horizontal2 pill" x="4" y="28" stroke={COLORS.oneGp.deepBlue} strokeWidth="2" fill={COLORS.oneGp.deepBlue} width="42" height="10" />
            <rect id="o1" className="outlinedPrimary radius" x="4" y="50" stroke={COLORS.oneGp.deepBlue} strokeWidth="8" fill="#fff" width="39" height="39" />
            <g transform="scale(1,-1) translate(0,-100)">
              <rect id="o2" className="outlinedSecondary radius" x="4" y="-48" stroke={COLORS.oneGp.deepBlue} strokeWidth="8" fill="#fff" width="39" height="39" />
              <rect id="s1" className="solidPrimary radius" x="54" y="-48" stroke={COLORS.oneGp.deepBlue} strokeWidth="2" fill={COLORS.oneGp.deepBlue} width="44" height="44" />
            </g>
          </svg>
        </div>
        <div className={props.callingComponent ? "text-wrap-cq" : "text-wrap"}>
        {props.isFinancialsDataLoading ? <FinancialLoader width={'368px'} fill={props.fill} loaderMessage={props.loaderMessage} /> :
          props.isArchival ? <ArchivalLoader width={'400px'} fill={COLORS.oneGp.deepBlue} /> : <CommonLoader width={'80px'} fill={COLORS.oneGp.deepBlue} />}
        </div>
      </div>
    </div>
  );
};

BVLoader20.propTypes = {
  bgColor: PropTypes.string,
  width: PropTypes.string,
  fill: PropTypes.string,
  isFinancialsDataLoading: PropTypes.bool,
  isArchival: PropTypes.bool,
  centerAlign: PropTypes.bool,
  loaderMessage: PropTypes.string
};

BVLoader20.defaultProps = {
  bgColor: '#f8f9fc',
  width: '50px',
  fill: COLORS.oneGp.deepBlue,
  isFinancialsDataLoading: false,
  isArchival: false,
  centerAlign: false,
  loaderMessage: ''
};

export default BVLoader20;